import { STRING_TRUNCATE_SIGN, ZERO } from '@constants';

export const truncateString = (input: string, maxLength: number) => {
  if (input.length <= maxLength) return input;

  return input.slice(ZERO, maxLength) + STRING_TRUNCATE_SIGN;
};
